import React from 'react';
import styled from 'styled-components';

import MainButton from '@elements/MainButton';
import ArrowLink from '../elements/ArrowLink';

const ButtonBlockWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 2.2rem;
	justify-content: ${({ centerButton }) => centerButton && 'center'};
`;

const ButtonBlock = ({ buttons, centerButton, ...props }) => {
	const primaryButton = buttons[0];
	const secondaryButton = buttons[1];

	return (
		<ButtonBlockWrapper centerButton={centerButton}>
			{primaryButton && (
				<MainButton
					linkUrl={primaryButton.linkUrl}
					anchorLink={primaryButton.anchorLink}
				>
					{primaryButton.linkText}
				</MainButton>
			)}
			{secondaryButton && (
				<ArrowLink
					link={secondaryButton.linkUrl}
					linkText={secondaryButton.linkText}
					{...props}
				/>
			)}
		</ButtonBlockWrapper>
	);
};

export default ButtonBlock;
